<template>
  <div class="m-l-50 m-t-30">
    <common-config :id="id" :form="form" :isLimit="false">
      <template slot="self-config">
        <el-form-item label="是否渲染">
          <el-radio class="radio" v-model="form.is_render" :label="1">是</el-radio>
          <el-radio class="radio" v-model="form.is_render" :label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="是否自动执行">
          <el-radio class="radio" v-model="form.is_auto" :label="1">是</el-radio>
          <el-radio class="radio" v-model="form.is_auto" :label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="执行条件" v-if="form.is_auto == 1">
          <div>
            <el-button @click="addCondition()">添加</el-button>
            <div v-for="(item, index) in form.exute_condition" class="m-t-10">
              <el-select v-model="item.field_id" placeholder="字段" class="w-150">
                <el-option
                  v-for="item in fieldOptions"
                  :label="item.field"
                  :value="item.field_id">
                  <span>{{ item.field }}（{{ item.title }}）</span>
                </el-option>
              </el-select>
              <el-select v-model="item.logic" placeholder="运算条件" class="w-110">
                <el-option
                  v-for="item in logicOption"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
              <el-input v-model="item.value" class="w-110 m-l-5"></el-input>
              <el-button type="danger" class="m-l-5" @click="deleteCondition(index)">删除</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="执行次数" v-if="form.is_auto == 1">
          <el-input v-model="form.times" class="w-110 m-l-5"></el-input>
        </el-form-item>
        <el-form-item label="监控周期(秒)" v-if="form.is_auto == 1">
          <el-input v-model="form.cycle" class="w-110 m-l-5"></el-input>
        </el-form-item>
        <el-form-item label="提示内容">
          <el-input type="textarea" v-model="form.arithmetic" class="w-300"></el-input>
        </el-form-item>
      </template>
    </common-config>
  </div>
</template>

<script>
  import http from '../../../../assets/js/http'
  import commonConfig from './commonConfig'
  export default {
    data() {
      return {
        isLoading: false,
        id: 0,
        contentId: '',
        modelId: '',
        form: {
          name: '',               // 操作名
          rule_name: '',          // 权限标识
          model_name: '',         // 所选模型
          is_render: 1,
          is_auto: 0,
          times: null,
          cycle: null,
          arithmetic: '',
          exute_condition: []
        },
        obj: {
          field_id: null,
          logic: null,
          value: null
        },
        logicOption: ['>', '≥', '=', '<', '≤', '≠'],
        fieldOptions: []
      }
    },
    methods: {
      addCondition() {
        let newObj = _.cloneDeep(this.obj)
        this.form.exute_condition.push(newObj)
      },
      deleteCondition(index) {
        this.form.exute_condition.splice(index, 1)
      },
      async getDetail() {
        await this.apiGet(`cms/deals/${this.id}`).then((res) => {
          if (res.code == 200) {
            this.form.name = res.data.content_name
            this.form.rule_name = res.data.rule_name
            this.form.model_name = res.data.model_name
            this.modelId = res.data.model_id
            if (res.data.config) {
              this.form.arithmetic = res.data.config.arithmetic
              this.form.cycle = res.data.config.cycle
              this.form.is_auto = res.data.config.is_auto
              this.form.is_render = res.data.config.is_render
              this.form.times = res.data.config.times
              this.form.exute_condition = res.data.config.exute_condition
            }
          } else {
            _g.dealError(this, res)
          }
        })
      },
      async getFields() {
        let arr = []
        let res = await this.apiGet(`cms/deals/fields/${this.modelId}`)
        return this.promiseHandler(arr, res)
      }
    },
    async created() {
      this.id = this.$route.params.id
      this.contentId = this.$route.params.contentId
      await this.getDetail()
      this.fieldOptions = await this.getFields()
    },
    components: {
      commonConfig
    },
    watch: {
      'form.is_auto'() {
        if (this.form.is_auto == 0) {
          this.form.exute_condition = []
          this.form.times = null
          this.form.cycle = null
        }
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// messageConfig.vue?0dbe5872